import { render, staticRenderFns } from "./PriceConfigDialog.vue?vue&type=template&id=37d27ed1"
import script from "./PriceConfigDialog.vue?vue&type=script&lang=js"
export * from "./PriceConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports